import React, { useContext, useEffect, useRef, useState } from "react";
import useCeo from "../../hooks/useCEO";
import { Spinner } from "../../components/Spinner";
import { TituloUnidadesConteo } from "../../components/customFunctionalComponents/components/TituloUnidadesConteo";
import { useUnidades } from "../../hooks/test/useUnidades";
import Paginacion from "../../components/customComponents/Paginacion";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import carroIcono from "../../assets/img/camion-disponible.png"
import { GestionEventoRoboCamionesModal } from "../../components/customComponents/Modals/GestionEventoRoboCamionesModal";
import { SocketContext } from "../../context/SocketContext";

export const UnidadesCamiones = () => {
    useCeo({
        title: "Lista de unidades camiones",
        description: "Lista de unidades camiones",
    });

    const [loading, setLoading] = useState(false);
    const [unidades, setUnidades] = useState(null);
    const [paginado, setPaginado] = useState([]);
    const debounceRef = useRef(null);
    const [allSelectCedis, allSetSelectCedis] = useState([]);
    const [selectCedis, setSelectCedis] = useState([]);
    const [listaNegocios, setListaNegocios] = useState([]);
    const [actiModal, setActiModal] = useState(false);
    const [eventAction, setEventAction] = useState("REGISTRAR");
    const [unidadSeleccionada, setUnidadSeleccionada] = useState();
    const { socket } = useContext(SocketContext);
    const modalClose = () => setActiModal(false);
    const [form, setForm] = useState({
        palabra: "",
        list_cedis: [],
        list_negocios: [],
    });
    const stateRef = useRef({ form, paginado });

    const {
        getListaCedis,
        getNegocios,
        getUnidadesSWAT,
    } = useUnidades();

    useEffect(() => {
        stateRef.current = { form, paginado }; // sincroniza en cada render
    }, [form, paginado]);

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        if (!socket) return;

        socket.on("new_event_robo_", async () => {
            console.log("new event robo actualizando Lista de unidades camiones");

            const { form: currentForm, paginado: currentPaginado } = stateRef.current;

            const negocioId = currentForm.list_negocios?.value || null;
            const cedisIds = currentForm.list_cedis?.length > 0
                ? currentForm.list_cedis.map(v => v.value)
                : [];

            const currentPage = currentPaginado.page || 1; // ← página actual del usuario

            await loadInfo("", negocioId, cedisIds, currentForm.palabra, currentPage);
        });

        return () => {
            socket.off("new_event_robo_");
        };
    }, [socket]);

    useEffect(() => {
        return () => {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
        };
    }, []);

    const loadData = async () => {
        let resp = await getListaCedis();
        if (resp.ok) {
            const cedisFiltrados = resp.cedis;
            setSelectCedis(cedisFiltrados);
            allSetSelectCedis(cedisFiltrados);

            let res = await getNegocios();
            if (!res.ok) return;

            const negocioIds = [
                ...new Set(cedisFiltrados.map((item) => item.negocio_id)),
            ];

            const negocios = res.negocios.filter((r) =>
                negocioIds.includes(r.negocio_id)
            );

            setListaNegocios(negocios);

            // default
            const negocioDefault = negocios.find(n => n.negocio_id === 2);

            if (negocioDefault) {
                const negocioSelect = {
                    value: negocioDefault.negocio_id,
                    label: negocioDefault.negocio_nombre,
                };

                setForm((prev) => ({
                    ...prev,
                    list_negocios: negocioSelect,
                }));

                // Filtrar CEDIS
                const cedisFiltradosPorNegocio = cedisFiltrados.filter(
                    c => c.negocio_id === negocioDefault.negocio_id
                );

                setSelectCedis(cedisFiltradosPorNegocio);

                // Cargar unidades con ese negocio
                await loadInfo("", negocioDefault.negocio_id);
            } else {
                await loadInfo("", null, [], "", 1);
            }
        }
    };

    const loadInfo = async (busqueda = "", idNegocio = null, cedisIds = [], search = "", newPage = 1) => {
        setLoading(true);
        const resp = await getUnidadesSWAT(newPage, busqueda, idNegocio, search, { arrayCedis: cedisIds });
        if (resp.ok) {
            setUnidades(resp.data.unidades || []);
            setPaginado({
                page: resp.data.paginacion.pagina || 1,
                limit: resp.data.paginacion.totalRegistros || 5,
                previousPage: resp.data.paginacion.previousPage || null,
                nextPage: resp.data.paginacion.nextPage || null,
                total: resp.data.paginacion.totalRegistros || 0,
                totalPaginas: resp.data.paginacion.totalPaginas || 1,
            });
        } else {
            setUnidades([]);
            setPaginado({ totalPaginas: 0, pagina: 1 });
        }
        setLoading(false);
    };

    // Manejar el cambio de página
    const handlePageChange = async (newPage) => {
        const negocioId = form.list_negocios?.value || null;

        const cedisIds = form.list_cedis?.length > 0
            ? form.list_cedis.map(v => v.value)
            : [];

        await loadInfo("", negocioId, cedisIds, form.palabra, newPage);
    };

    const filterCedis = async (values) => {
        const negocioId = form.list_negocios?.value || null;

        const cedisIds = values && values.length > 0
            ? values.map(v => v.value)
            : [];

        setForm(prev => ({
            ...prev,
            list_cedis: values,
        }));

        await loadInfo("", negocioId, cedisIds, form.palabra, 1);
    };

    const filterNegocios = async (value) => {
        if (value) {
            const negocioId = value.value;

            const cedisFiltrados = allSelectCedis.filter(item =>
                item.negocio_id === negocioId
            );

            setSelectCedis(cedisFiltrados);

            setForm(prev => ({
                ...prev,
                list_negocios: value,
                list_cedis: []
            }));

            await loadInfo("", negocioId, [], form.palabra, 1);
        } else {
            setForm({
                ...form,
                list_negocios: null,
                list_cedis: [],
            });

            setSelectCedis(allSelectCedis);
            await loadInfo("", null, [], "", 1);
        }
    };

    const handleSearch = async (valor) => {
        const negocioId = form.list_negocios?.value || null;

        const cedisIds = form.list_cedis?.length > 0
            ? form.list_cedis.map(v => v.value)
            : [];

        setForm(prev => ({
            ...prev,
            palabra: valor,
        }));

        // limpiar timeout anterior
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        // nuevo timeout
        debounceRef.current = setTimeout(async () => {
            await loadInfo("", negocioId, cedisIds, valor, 1);
        }, 500); // ⏱ 500ms (puedes ajustar)
    };

    const loadInfoUnit = async (unidad) => {
        if (unidad.evento_activo) {
            setEventAction("EDITAR");
        } else {
            setEventAction("REGISTRAR");
        }
        setActiModal(true);
        setUnidadSeleccionada(unidad);
    }

    const refreshData = async () => {
        const negocioId = form.list_negocios?.value || null;

        const cedisIds = form.list_cedis?.length > 0
            ? form.list_cedis.map(v => v.value)
            : [];

        const currentPage = paginado.page || 1;

        await loadInfo("", negocioId, cedisIds, form.palabra, currentPage);
    };

    return (
        <>
            {loading && <Spinner />}
            <div className="row mt-1 fadeInDown animated delay-01s">
                {listaNegocios.length > 1 && (

                    <div className="col-4 col-md-4 col-lg-6 col-xl-4 ms-auto">
                        <Select
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            menuPortalTarget={document.body}
                            options={listaNegocios.map((x) => {
                                return { value: x.negocio_id, label: x.negocio_nombre };
                            })}
                            isMulti={false}
                            className="form-control selectCedis mb-4"
                            classNamePrefix={"select"}
                            value={form.list_negocios}
                            onChange={filterNegocios}
                            placeholder="Selecciona negocio"
                        />
                    </div>

                )}
                <div className="col-4 col-md-12 col-lg-6 col-xl-4 ms-auto">
                    <Select
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        menuPortalTarget={document.body}
                        options={selectCedis.map((x) => ({
                            value: x.cedis_id,
                            label: x.nombre_cedis,
                        }))}
                        isMulti
                        className="form-control selectCedis mb-4"
                        classNamePrefix={"select"}
                        value={form.list_cedis}
                        onChange={(values) => {
                            filterCedis(values);
                        }}
                        placeholder="Selecciona cedis"
                    />
                </div>
                <div className="col-4 col-md-12 col-lg-6 col-xl-4 me-auto inputWithIcon">
                    <input
                        className="form-control selectCedis"
                        placeholder="BUSCAR UNIDAD"
                        name="palabra"
                        value={form.palabra}
                        onChange={(e) => {
                            handleSearch(e.target.value);
                        }}
                    ></input>
                    <button disabled={true}>
                        <FontAwesomeIcon id="iconoBuscar" icon={faMagnifyingGlass} />
                    </button>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <TituloUnidadesConteo
                        longitud={paginado.total}
                    />
                    <div className="row">
                        {unidades && unidades.length > 0 ? (
                            unidades.map((unidad) => {
                                return (
                                    <div key={unidad.unidad_id} className="col-12 mb-3" onClick={() => loadInfoUnit(unidad)}>
                                        <div className="card shadow-sm p-3">
                                            <div className="row">

                                                <div
                                                    className="col-md-2 text-center bordersLeftRounded"
                                                    style={{ background: "#F5F5F5" }}
                                                >
                                                    <div className="contenedorCarro-salida">
                                                        <img
                                                            src={carroIcono}
                                                            alt=""
                                                            className="img-fluid"
                                                            style={{ maxWidth: "55px", background: "#f5f5f5" }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <strong>Unidad:</strong> {unidad.unidad_numero}
                                                </div>

                                                <div className="col-md-3">
                                                    <strong>CEDIS:</strong> {unidad.cedi?.nombre_cedis}
                                                </div>

                                                <div className="col-md-3">
                                                    {
                                                        unidad.evento_activo ? (
                                                            <>
                                                                <p style={{ color: "red", fontSize: "14px", fontWeight: "bold" }}>{unidad.evento_seguridad}</p>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <strong>Status:</strong>
                                                                <span style={{ color: unidad.status?.color, marginLeft: 5 }}>
                                                                    {unidad.status?.nombre}
                                                                </span>
                                                            </>
                                                        )
                                                    }
                                                </div>

                                                {/* <div className="col-md-3">
                                                    <strong>Tipo:</strong> {unidad.tipo_unidad?.tipo_unidad}
                                                </div> */}

                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="col-12 text-center">
                                No hay unidades disponibles
                            </div>
                        )}
                    </div>
                    <div className="position-relative">
                        <Paginacion paginado={paginado} onPageChange={handlePageChange} />
                    </div>
                </div>
            </div>
            {
                actiModal &&
                <GestionEventoRoboCamionesModal
                    isOpen={actiModal}
                    onClose={() => modalClose(false)}
                    onConfirm={() => modalClose(false)}
                    unidad={unidadSeleccionada}
                    eventAction={eventAction}
                    refreshData={refreshData}
                />
            }

        </>
    )
};